import { useState, useEffect } from "react";
import News from "./pages/News/News";
import "swiper/css";
import Works from "./pages/Work";
import Gallery from "./pages/Gallery";
import Layout from "./components/Layout/Layout";
import Services from "./pages/Services";
import { Route, Routes } from "react-router-dom";
import CompanyStartUp from "./pages/About/companyStartUp/CompanyStartUp";
import CompanyGoals from "./pages/About/companygoals/CompanyGoals";
import ManagerDetails from "./pages/About/managerDetails/ManagerDetails";
import EmployeeDetails from "./pages/About/employeedetails/EmployeeDetails";
import RegistrationCertificate from "./pages/About/registrationCertificate/RegistrationCertificate";
import Downloads from "./pages/downloads/Downloads";

import Payment from "./pages/payment";

import DateConverter from "./pages/date-converter/DateConverter";
import PreetiToUnicode from "./pages/preeti-to-unicode/PreetiToUnicode";
import UnicodeToPreeti from "./pages/unicode-to-preeti/UnicodeToPreeti";

import Homepage from "./pages/Homepage";

import Testimonials from "./pages/Homepage/Testonomials/Testonomials";
import MainAbout from "./pages/About/mainAbout/MainAbout";
import StaffDetails from "./pages/staffDetails/StaffDetails";

import MorePhotos from "./pages/Gallery/PhotosAndVideos/MorePhotosAndVideos";
import Photos from "./pages/Gallery/PhotosAndVideos/PhotosAndVideos";

import JobDetails from "./pages/user-dashboard/job-details/JobDetails";
import Profile from "./pages/user-dashboard/profile/Profile";
import UploadDocuments from "./pages/user-dashboard/upload-document/UploadDocument";
import ReceivedDocuments from "./pages/user-dashboard/received-documents/ReceivedDocument";
import LedgerDetails from "./pages/user-dashboard/ledger/LedgerDetails";

import LanguageTranslate from "./pages/language-translate/LanguageTranslate";
import Branch from "./pages/branches/Branch";
import ImportantLinks from "./pages/importantLinks/ImportantLinks";
import ServiceDetails from "./pages/Services/ServiceDetails";
import Notice from "./pages/notice/Notice";
import AcAndTax from "./pages/Services/acAndTax/AcAndTax";
import Calender from "./pages/calender/";

import SideBarLayout from "./components/sidebar-layout/SideBarLayout";

import Registration from "./pages/auth/registration/Registration";
import ClientLogin from "./pages/auth/clientLogin/ClientLogin";
import StaffLogin from "./pages/auth/staffLogin/StaffLogin";
import PrivateCompanyRegistration from "./pages/servicesForms/BusinessAndCompany/PrivateCompanyRegistration/PrivateCompanyRegistration";
import PublicCompanyRegistration from "./pages/servicesForms/BusinessAndCompany/PublicCompanyRegistration/PublicCompanyRegistration ";
import NonProfitCompanyRegistration from "./pages/servicesForms/BusinessAndCompany/NonProfitCompanyRegistration/NonProfitCompanyRegistration ";
import GhareluCompanyRegistrationA from "./pages/servicesForms/BusinessAndCompany/GhareluCompanyRegistrationA/GhareluCompanyRegistrationA";
import WardRegistration from "./pages/servicesForms/BusinessAndCompany/WardRegistrationA/WardRegistrationA";
import TrademarkRegistration from "./pages/servicesForms/BusinessAndCompany/TradeMarkRegistration/TradeMarkRegistration ";
import EximCodeRegistration from "./pages/servicesForms/BusinessAndCompany/EximCodeRegistration/EximCodeRegistration ";
import BanijyaRegistration from "./pages/servicesForms/BusinessAndCompany/BanijyaCompanyRegistration/BanijyaCompanyRegistration ";
import CalenderPrinting from "./pages/servicesForms/DesignAndPrinting/CalenderPrinting/CalenderPrinting";
import BillPrinting from "./pages/servicesForms/DesignAndPrinting/BillPrinting/BillPrinting";
import BanijyaCompanyRegistrationB from "./pages/servicesForms/BusinessAndCompany/BanijyaCompanyRegistrationB/BanijyaCompanyRegistrationB";
import BanijyaCompanyRegistration from "./pages/servicesForms/BusinessAndCompany/BanijyaCompanyRegistration/BanijyaCompanyRegistration ";
import GhareluCompanyRegistrationB from "./pages/servicesForms/BusinessAndCompany/GhareluCompanyRegistrationB/GhareluCompanyRegistrationB";
import WardRegistrationA from "./pages/servicesForms/BusinessAndCompany/WardRegistrationA/WardRegistrationA";
import WardRegistrationB from "./pages/servicesForms/BusinessAndCompany/WardRgistrataionB/WardRgistrataionB";
import VatRegistrationA from "./pages/servicesForms/BusinessAndCompany/VatRegistration/VatRegistration";
import VatRegistrationB from "./pages/servicesForms/BusinessAndCompany/VatRegistrationB/VatRegistrationB";
import SSFRegistrationA from "./pages/servicesForms/BusinessAndCompany/SSFRegistrationA/SSFRegistrationA";
import SSFRegistrationB from "./pages/servicesForms/BusinessAndCompany/SSFRegistrationB/SSFRegistrationB";
import NewsDetails from "./pages/news-details/NewsDetails";
import AnualReturns from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/AnualReturns/AnualReturns";
import ShareLagat from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/ShareLagatProvideForm/ShareLagatProvideForm";
import EximCodeRenewal from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/EximCodeRenewal/EximCodeRenewal";
import BanijyaRenewal from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/BanijyaRenewal/BanijyaRenewal";
import WardRenewal from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/WardRenewal/WardRenewal";
import GhareluRenew from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/GhareluRenew/GhareluRenew";
import CompanyObjectChange from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/CompanyObjectChange/CompanyObjectChange";
import CompanyCapitalIncrease from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/CompanyCapitalIncrease/CompanyCapitalIncrease";
import CompanyAddressChange from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/CompanyAddressChange/CompanyAddressChange";
import CompanyNameChange from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/ComapanyNameChange/ComapanyNameChange";
import CompanyShareSalesPurches from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/CompanyShareSalesPurches/CompanyShareSalesPurches";
import FormBranch from "./components/common/forms/FormBranch";
import VCardPrinting from "./pages/servicesForms/DesignAndPrinting/VCardPrinting";
import ThreeMonthsReturn from "./pages/servicesForms/BusinessAndCompany/AmendmentAndUpdate/3MonthsReturnForm/ThreeMonthsReturn";
import ConstructionLicense from "./pages/servicesForms/Others/ConstructionLicense";
import Videos from "./pages/Gallery/PhotosAndVideos/Videos";
import AccountAndTax from "./pages/servicesForms/AccountAndTaxtation/AccountAndTax";
import PrivateToPublicConversion from "./pages/servicesForms/BusinessAndCompany/companyConversion/privateCompanyToPublic/PrivateToPublicConversion";
import PrivateCompanyDeRegistration from "./pages/servicesForms/BusinessAndCompany/companyConversion/privateCompanyDeregistration/PrivateCompanyDeRegistration";
import api from "./api/api";
import OthersDynamicServices from "./pages/servicesForms/Others/OthersDynamicServices";
import DynamicDesignAndPrinting from "./pages/servicesForms/DesignAndPrinting/DynamicDesignAndPrinting";
import Category from "./pages/News/Category";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategory, fetchNews } from "./features/news/NewsSlice";
import NewsNavbar from "./pages/News/NewsNavbar";
import NewsLayout from "./pages/News/NewsLayout";
import EditProfile from "./pages/user-dashboard/profile/EditProfile";
import KycForm from "./pages/Homepage/KycForm/KycForm";
import AboutLayout from "./pages/About/mainAbout/AboutLayout";
import sidebar from "./pages/staffSidebar/Array";
import ProtectedRoute from "./hocs/ProtectedRoute";
import CompanyEdit from "./pages/staffSidebar/CompanyDetails/CompanyEdit";


function PageNotFound() {
  return (
    <div>
      <h2>404 Page not found</h2>
    </div>
  );
}




function App() {
  const { news, category } = useSelector((state) => state.news);

  const dispatch = useDispatch();

  const [serviceRoutes, setServiceRoutes] = useState([
    {
      path: "private-company-registration",
      component: <PrivateCompanyRegistration />,
    },

    {
      path: "public-company-registration",
      component: <PublicCompanyRegistration />,
    },
    {
      path: "nonprofit-company-registration",
      component: <NonProfitCompanyRegistration />,
    },
    {
      path: "banijya-registration-B",
      component: <BanijyaCompanyRegistration />,
    },
    {
      path: "gharelu-registrationA",
      component: <GhareluCompanyRegistrationA />,
    },
    {
      path: "ward-registration",
      component: <WardRegistration />,
    },
    {
      path: "exim-code-registration",
      component: <EximCodeRegistration />,
    },
    {
      path: "trademark-registration",
      component: <TrademarkRegistration />,
    },
    {
      path: "calender-printing",
      component: <CalenderPrinting />,
    },
    {
      path: "bill-printing",
      component: <BillPrinting />,
    },
    {
      path: "vat-registration",
      component: <VatRegistrationB />,
    },
    {
      path: "ssf-registration",
      component: <SSFRegistrationA />,
    },
    {
      component: <ThreeMonthsReturn />,
      path: "three-months-return",
    },
    {
      component: <AnualReturns />,
      path: "annual-returns",
    },
    {
      component: <ShareLagat />,
      path: "share-lagat",
    },
    {
      component: <CompanyShareSalesPurches />,
      path: "share-sales-purchase",
    },
    {
      component: <CompanyNameChange />,
      path: "company-name-change",
    },
    {
      component: <CompanyAddressChange />,
      path: "company-address-change",
    },
    {
      component: <CompanyCapitalIncrease />,
      path: "company-capital-increase",
    },
    {
      component: <CompanyObjectChange />,
      path: "company-objective-change",
    },
    {
      component: <GhareluRenew />,
      path: "gharelu-renew",
    },
    {
      component: <WardRenewal />,
      path: "ward-renew",
    },

    {
      component: <BanijyaRenewal />,
      path: "banijya-renew",
    },
    {
      component: <EximCodeRenewal />,
      path: "exim-code-renew",
    },
    {
      path: "construction-license",
      component: <ConstructionLicense />,
    },
    {
      component: <PrivateCompanyDeRegistration />,
      path: "private-deregistration",
    },
    {
      component: <PrivateToPublicConversion />,
      path: "private-to-public-conversion",
    },
    {
      component: <AccountAndTax />,
      path: "ac-and-tax",
    },
  ]);

  

  // Protected Route
  const Protect = (child) => {
    return <ProtectedRoute>{child}</ProtectedRoute>
  }


  useEffect(() => {
    dispatch(fetchNews());
    dispatch(fetchCategory());
  }, [dispatch]);

  // Design and printing types
  useEffect(() => {
    api
      .get("/design-and-printing/types/")
      .then((response) => {
        const newServices = response.data.map((item) => {
          return {
            path: item.codename,
            component: <DynamicDesignAndPrinting />,
          };
        });

        setServiceRoutes((prev) => [...prev, ...newServices]);
      })
      .catch((error) => {});
  }, []);

  // other types
  useEffect(() => {
    api
      .get("/services/others/types/")
      .then((response) => {
        const newServices = response.data.map((item) => {
          return {
            path: item.codename,
            component: <OthersDynamicServices />,
          };
        });

        setServiceRoutes((prev) => [...prev, ...newServices]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div className="font-Bree relative min-h-screen w-full">
      {/* <Videos /> */}
      {/* <WardRegistrationB/> */}
      {/* <GhareluCompanyRegistrationB/> */}
      {/* <SSFRegistrationB/> */}
      <Routes>
        <Route path="/" element={<Layout  />}>

          <Route index element={<Homepage />} />  


          <Route path="kyc-form" element={<KycForm />} />
          <Route path="payment" element={<Payment />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="downloads" element={<Downloads />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/date-converter" element={<DateConverter />} />
          <Route path="/language-translate" element={<LanguageTranslate />} />
          <Route path="/preeti-to-unicode" element={<PreetiToUnicode />} />
          <Route path="/unicode-to-preeti" element={<UnicodeToPreeti />} />
          <Route path="/important-links" element={<ImportantLinks />} />
          <Route path="/notices" element={<Notice />} />
          <Route path="/branches" element={<Branch />} />

          <Route path="/about" element={<AboutLayout />}>
            {/* <Route index element={<CompanyStartUp />} /> */}

            <Route index element={<CompanyStartUp />} />
            <Route path="/about/company-startup" element={<CompanyStartUp />} />
            {/* <Route path="/about/calender" element={<Calender />} /> */}
            <Route path="/about/company-goals" element={<CompanyGoals />} />
            <Route path="/about/manager-details" element={<ManagerDetails />} />
            <Route
              path="/about/employee-details"
              element={<EmployeeDetails />}
            />
            <Route path="/about/staff-details" element={<StaffDetails />} />
            <Route
              path="/about/registration-certificate"
              element={<RegistrationCertificate />}
            />
          </Route>

          {/* News */}
          <Route path="/news" element={<NewsLayout />}>
            <Route index element={<News />} />
            {news.map((item, index) => {
              return (
                <Route
                  key={index}
                  path={`/news/${item.category_name_eng}/:slug`}
                  element={<NewsDetails />}
                />
              );
            })}

            {/* <Route path="/news/category" element={<Category />} /> */}
            {category.map((item, index) => {
              return (
                <Route
                  key={index}
                  // path="news/"
                  path={`${item.name_eng}`}
                  element={<Category />}
                />
              );
            })}
          </Route>
          {/* End Of News */}

          <Route path="services">
            <Route index element={<Services />} />
            <Route path="service-details">
            
              <Route index element={ 
                // <ProtectedRoute>
                  <ServiceDetails />
                  
                 
                  
              } />       
              {serviceRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    Protect(route.component)
                    // route.component
                  
                  }
                />

              ))}
              
             
              {/* <Route path=":slug" element={<PrivateCompanyRegistration />} /> */}
            </Route>
          </Route>

          <Route path="/gallery" element={<Gallery />}>
            <Route index element={<Photos />} />
            <Route path=":slug" element={<MorePhotos />} />
          </Route>
          <Route path="/works" element={<Works />} />

          <Route path="/registration" element={<Registration />} />
          <Route
            path="/private-company-registration"
            element={<PrivateCompanyRegistration />}
          />

          <Route path="/client-login" element={<ClientLogin />} />
          <Route path="/staff-login" element={<StaffLogin />} />
          <Route path="/registartion" element={<Registration />} />

          <Route
            path="/staff/*"
            element={<SideBarLayout  />}
          />

          <Route path="/client-login" element={<ClientLogin />} />
          <Route path="/staff-login" element={<StaffLogin />} />
          <Route path="/registartion" element={<Registration />} />
        </Route>

        <Route path="client" element={<Layout />}>
          <Route index element={<Homepage />} />
          <Route path="job-details" element={<JobDetails />} />
          <Route path="profile" element={<Profile />} />
          <Route path="edit-profile/:id" element={<EditProfile />} />
          <Route path="upload-documents" element={<UploadDocuments />} />
          <Route path="received-documents" element={<ReceivedDocuments />} />
          <Route path="ledger-details" element={<LedgerDetails />} />
        </Route>

        <Route path="/staff" element={<Layout />}>
          <Route index element={<Homepage />} />
        </Route>

        <Route path="*" element={<h1 className="text-2xl">Page Not found</h1>} />
      </Routes>
    </div>
  );
}

export default App;
